module.exports = {"pathContext":{"title":"Remembering Bunji Tagawa","createdAt":"a day ago","by":"yaseen-rob","comments":[]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/comment-17765351.json
// module id = 828
// module chunks = 189730916535050